import FormatDate from 'Assets/js/dateformatter';

function stringToArray(value) {
  let array = [];
  if (value.indexOf(',') !== -1) {
    array = value.split(',');
  } else if (value !== '') {
    array = [value];
  } else {
    array = [];
  }
  return array;
}

function arrayToString(value) {
  if (typeof value === 'object') {
    return value.join(',');
  }
  return value;
}

function objectToArray(data, obj) {
  const arr = [];
  Object.keys(obj).forEach((key) => {
    arr.push({
      value: obj[key],
      label: obj[key],
      children: (() => {
        if (data[key]) {
          return objectToArray(data, data[key]);
        }
        return [];
      })(data, key),
    });
  });
  return arr;
}

function diffMinutesByNow(dateStr) {
  const date = new Date(dateStr.replace(/-/g, '/'));
  return parseInt((new Date().getTime() - date.getTime()) / 1000 / 60, 10);
}

// 获取cookie
function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return (arr[2]);
  }
  return null;
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expireDays) {
  const exDate = new Date();
  exDate.setDate(exDate.getDate() + expireDays);
  document.cookie = `${cName}=${escape(value)}${((expireDays === null) ? '' : `;expires=${exDate.toGMTString()}`)}`;
}

// 删除cookie
function delCookie(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cookieValue = getCookie(name);
  if (cookieValue !== null) {
    document.cookie = `${name}=${cookieValue};expires=${exp.toGMTString()}`;
  }
}

// 从浏览器地址获取参数
function getParamFromUrl(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

// 从字符串获取参数
function getParam(name, string) {
  const reg = new RegExp(`(^|[&,?])${name}=([^&]*)(&|$)`, 'i');
  const r = decodeURIComponent(string).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

// 正整数
function isPositiveInteger(value) {
  const reg = /^\+?[1-9][0-9]*$/;
  return reg.test(value);
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
function handleTree(data, idName, parentIdName, childrenName, rootIdName) {
  const id = idName || 'id';
  const parentId = parentIdName || 'parentId';
  const children = childrenName || 'children';
  const rootId =
  rootIdName ||
    Math.min(...data.map((item) => {
        return item[parentId];
      })) ||
    0;
  // 对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data));
  // 循环所有项
  const treeData = cloneData.filter((father) => {
    const branchArr = cloneData.filter((child) => {
      // 返回每一项的子级数组
      return father[id] === child[parentId];
    });
    // eslint-disable-next-line no-param-reassign
    branchArr.length > 0 ? (father[children] = branchArr) : '';
    // 返回第一层
    return father[parentId] === rootId;
  });
  return treeData !== '' ? treeData : data;
}

export default {
  arrayToString,
  stringToArray,
  objectToArray,
  getCookie,
  setCookie,
  delCookie,
  getParam,
  FormatDate,
  getParamFromUrl,
  diffMinutesByNow,
  isPositiveInteger,
  handleTree,
};



// WEBPACK FOOTER //
// ./src/utils/index.js